import { APISettings } from '../config.js';
import loginMethods from '../resources/loginMethods.js'

export default {
    name: "productMethods",

    async getProducts() {
        //console.log("Starting request");
        try {
            const response = await fetch("/backend/products", {
                method: 'GET',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                }
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    },
    async getBases() {
        //console.log("Starting request");
        try {
            const response = await fetch("/backend/bases", {
                method: 'GET',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                }
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    },
    async postBases(obj) {
        try {
            const response = await fetch("/backend/bases", {
                method: 'POST',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                },
                body: JSON.stringify(obj)
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    },
    async deleteBases(base) {
        try {
            const response = await fetch("/backend/bases/" + base.id, {
                method: 'DELETE',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                },
                body: JSON.stringify(base)
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    },
    async updateYield(obj) {
        try {
            const response = await fetch("/backend/yield", {
                method: 'POST',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                },
                body: JSON.stringify(obj)
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    },
    async updatePrice(obj) {
        try {
            const response = await fetch("/backend/price", {
                method: 'POST',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                },
                body: JSON.stringify(obj)
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    },
    async resetPrice(obj) {
        try {
            const response = await fetch("/backend/resetPrice", {
                method: 'POST',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                },
                body: JSON.stringify(obj)
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    },
    async updateProductOrder(obj) {
        try {
            const response = await fetch("/backend/productOrder", {
                method: 'POST',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                },
                body: JSON.stringify(obj)
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    },
    async getGroups() {
        //console.log("Starting request");
        try {
            const response = await fetch("/backend/groups", {
                method: 'GET',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                }
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    },
    async postGroup(obj) {
        try {
            const response = await fetch("/backend/groups", {
                method: 'POST',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                },
                body: JSON.stringify(obj)
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    },
    async deleteGroup(obj) {
        try {
            const response = await fetch("/backend/groups", {
                method: 'DELETE',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                },
                body: JSON.stringify(obj)
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    },
    async addSubProductToGroup(obj) {
        try {
            const response = await fetch("/backend/productGroup", {
                method: 'POST',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                },
                body: JSON.stringify(obj)
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    },
    async deleteSubProductFromGroup(obj) {
        try {
            const response = await fetch("/backend/productGroup", {
                method: 'DELETE',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                },
                body: JSON.stringify(obj)
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    },
}